import marketingHelpers from "./marketing-helpers.cjs"

const { safeUrl, sanitizeAttributionValue } = marketingHelpers

const MEMORY_KEY = "__wwServiceAttribution"
const CAMPAIGN_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "gbraid",
  "wbraid",
  "msclkid",
]

const emptyCampaign = () =>
  CAMPAIGN_KEYS.reduce((values, key) => ({ ...values, [key]: "" }), {})

const readStored = () => {
  if (typeof window === "undefined") return null
  const stored = window[MEMORY_KEY]
  return stored && typeof stored === "object" ? stored : null
}

const campaignFromUrl = url => {
  const campaign = emptyCampaign()
  CAMPAIGN_KEYS.forEach(key => {
    campaign[key] = sanitizeAttributionValue(url.searchParams.get(key))
  })
  return campaign
}

export const captureMarketingAttribution = () => {
  if (typeof window === "undefined") return null

  const url = new URL(window.location.href)
  const stored = readStored()
  const currentCampaign = campaignFromUrl(url)
  const hasCampaign = Object.values(currentCampaign).some(Boolean)
  const fallbackLast = stored?.last || emptyCampaign()
  const last = hasCampaign ? currentCampaign : fallbackLast
  const first = stored?.first || currentCampaign
  const rawReferrer = safeUrl(document.referrer)
  const externalReferrer = rawReferrer.startsWith(window.location.origin)
    ? ""
    : rawReferrer
  const state = {
    landing_page: stored?.landing_page || url.pathname,
    referrer: stored?.referrer || externalReferrer,
    first,
    last,
  }

  // Keep attribution in page memory only. It is submitted only when the visitor
  // deliberately sends a form and is cleared by a hard refresh/browser close.
  window[MEMORY_KEY] = state

  return state
}

export const getMarketingAttributionFields = () => {
  if (typeof window === "undefined") return {}

  const state = captureMarketingAttribution() || readStored()
  const url = new URL(window.location.href)
  const first = state?.first || emptyCampaign()
  const last = state?.last || emptyCampaign()

  return {
    landing_page: state?.landing_page || url.pathname,
    page_path: url.pathname,
    page_url: safeUrl(url.toString(), true),
    referrer: state?.referrer || "",
    ...last,
    first_utm_source: first.utm_source || "",
    first_utm_medium: first.utm_medium || "",
    first_utm_campaign: first.utm_campaign || "",
    first_utm_term: first.utm_term || "",
    first_utm_content: first.utm_content || "",
    last_utm_source: last.utm_source || "",
    last_utm_medium: last.utm_medium || "",
    last_utm_campaign: last.utm_campaign || "",
    last_utm_term: last.utm_term || "",
    last_utm_content: last.utm_content || "",
  }
}

export const MARKETING_ATTRIBUTION_FIELDS = [
  "landing_page",
  "page_path",
  "page_url",
  "referrer",
  ...CAMPAIGN_KEYS,
  "first_utm_source",
  "first_utm_medium",
  "first_utm_campaign",
  "first_utm_term",
  "first_utm_content",
  "last_utm_source",
  "last_utm_medium",
  "last_utm_campaign",
  "last_utm_term",
  "last_utm_content",
]
